<div class="wrapper" [class.no-value]="!modelValue">
	<ng-container *ngFor="let kvp of keyValuePairs">
		<div class="key-value-pair-container">
			<div class="pair">
				<div class="label">
					{{ kvp.key }} <em class="type">[{{ kvp.isArray ? 'array' : kvp.type }}<span *ngIf="kvp.type === 'object'"> {{ kvp.isArray ? '[' + kvp.numChilds + ']' : '{' + kvp.numChilds + '}' }}</span>]</em>
					<span class="expand-add small-button" [hidden]="kvp.type !== 'object'" (click)="expanded[kvp.key] = !expanded[kvp.key];newObjects[kvp.key] = newObjects[kvp.key] ? newObjects[kvp.key] : {key:'',value:''}">
						<i class="fa fa-plus"></i>
					</span>
					<span *ngIf="parent?.isArray" class="copy-button small-button" (click)="duplicate(kvp, parent)">
						<i class="fa fa-copy"></i>
					</span>
					<span class="delete-button small-button" (click)="remove(kvp)">
						<i class="fa fa-trash"></i>
					</span>
					<div [hidden]="!expanded[kvp.key]" *ngIf="newObjects[kvp.key]" class="add-row" [class.with-object]="kvp.type === 'object' && !kvp.isArray">
						<input
							*ngIf="kvp.type === 'object' && !kvp.isArray"
							type="text"
							placeholder="field key"
							[(ngModel)]="newObjects[kvp.key].key"
						/>
						<span 
							*ngIf="kvp.type === 'object' && !kvp.isArray"
						>
							:
						</span>
						<input
							type="text"
							placeholder="JSON or text"
							[(ngModel)]="newObjects[kvp.key].value"
						/>
						<button (click)="addChild(kvp, newObjects[kvp.key].value, newObjects[kvp.key].key);newObjects[kvp.key] = null" class="button add-child-button">
							add child
						</button>
					</div>
				</div>
				<input
					*ngIf="kvp.type === 'string' || kvp.type === 'number'"
					[type]="kvp.type === 'string' ? 'text' : 'number'"
					[(ngModel)]="kvp.value"
					(ngModelChange)="onValueChange($event, kvp)"
				/>
				<bb-check
					*ngIf="kvp.type === 'boolean'"
					[(ngModel)]="kvp.value"
					(ngModelChange)="onValueChange($event, kvp)"
				></bb-check>
				<div class="object-wrapper">
					<bb-object-editor
						*ngIf="kvp.type === 'object'"
						[(ngModel)]="kvp.value"
						(ngModelChange)="onValueChange($event, kvp)"
						[parent]="kvp"
						(duplicateRequest)="onDuplicateRequest($event, kvp)"
					></bb-object-editor>
				</div>
			</div>
		</div>
	</ng-container>
</div>
